<template>
  <div>
    <div v-for="(item,index) in showDataList" :key="index">
      <div class="title" @click="onItemClick(item,index)" style="cursor:pointer">
        <a-icon :type="item.collapsed?'down':'up'" v-if="showChildren(item)" :style="{ fontSize: '10px' }"/>
        <p v-else style="width: 10px;display: inline-block"/>
        <span :class="[isSelected($route,item)?'sel-title':'def-title']"
              :style="{'font-weight':showChildren(item)?'650':'normal' }">{{ item.meta.title }}</span>
      </div>
      <div v-if="showChildren(item) &&!item.collapsed">
        <custom-group-menu :data-list="item.children"></custom-group-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomGroupMenu',
  props: {
    dataList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    dataList: function(value) {
      this.showDataList = this.getShowDataList(value)
    },
    $route: function() {
      this.updateSelectedMenu()
    }
  },
  data() {
    return {
      currentPath: '',
      showDataList: []
    }
  },
  mounted() {
    this.showDataList = this.getShowDataList(this.dataList)
    this.updateSelectedMenu()
  },
  methods: {
    isSelected(currentRoute, route) {
      if (currentRoute && route) {
        if (currentRoute.path === route.path || currentRoute.name === route.name) {
          return true
        }
        if (currentRoute.meta && currentRoute.meta.groupName && currentRoute.meta.groupName === route.name) {
          return true
        }
      }
      return false
    },
    updateSelectedMenu() {
      const routes = this.$route.matched.concat()
      this.currentPath = routes[routes.length - 1].path
    },
    getShowDataList(list) {
      const newList = []
      if (list && list.length > 0) {
        list.forEach((item, i, a) => {
          if (!item.hidden) {
            item.collapsed = false
            newList.push(item)
          }
        })
      }
      return newList
    },
    showChildren(item) {
      return !item.hidden && item.children && item.children.length > 0 && !item.hideChildrenInMenu
    },

    onItemClick(item, index) {
      if (this.showChildren(item)) {
        const list = [...this.showDataList]
        list[index].collapsed = !list[index].collapsed
        this.showDataList = list
      } else if (this.currentPath !== item.path) {
        this.$router.push({ path: item.path })
      }
    }
  }
}
</script>
<style scoped>
.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 22px;
  white-space: nowrap;
}

.def-title {
  color: #444444;
  margin-left: 10px;
}

.sel-title {
  color: #FAAD14;
  font-weight: 650;
  margin-left: 10px;
}
</style>